<router-outlet></router-outlet>
<!-- <div class="z-50 cursor-pointer transition-all delay-100 h-full">
    <div class="fixed bottom-4 flex flex-col bg-purple-500 p-4 rounded-full z-50 cursor-pointer transition-all delay-100"
        [ngClass]="{'invisible': !displayButtonsParams, 'visible': displayButtonsParams}"
        [class.right-24]="displayButtonsParams" [class.right-4]="!displayButtonsParams"
        (click)="openModal('audit', 'fromEdit')">
        <mat-icon class="text-white" style="width: 30px; height: 30px; font-size: 30px;"
            [svgIcon]="'heroicons_solid:clipboard-document-list'"></mat-icon>
    </div>
    <div class="fixed flex bottom-4 flex-col bg-orange-500 p-4 rounded-full z-50 cursor-pointer transition-all delay-100"
        [ngClass]="{'invisible': !displayButtonsParams, 'visible': displayButtonsParams}"
        [class.right-44]="displayButtonsParams" [class.right-4]="!displayButtonsParams"
        (click)="openModal('casse-pann', 'fromEdit')">
        <mat-icon class="text-white" style="width: 30px; height: 30px; font-size: 30px;"
            [svgIcon]="'heroicons_solid:wrench-screwdriver'"></mat-icon>
    </div>

    <div class="fixed flex right-4 flex-col bg-yellow-500 p-4 rounded-full z-50 cursor-pointer transition-all delay-100"
        [ngClass]="{'invisible': !displayButtonsParams, 'visible': displayButtonsParams}"
        [class.bottom-4]="!displayButtonsParams" [class.bottom-44]="displayButtonsParams"
        (click)="openModal('non-conf', 'fromEdit')">
        <mat-icon class="text-white" style="width: 30px; height: 30px; font-size: 30px;"
            [svgIcon]="'heroicons_solid:exclamation-circle'"></mat-icon>
    </div>

    <div class="fixed flex right-4 flex-col bg-red-500 p-4 rounded-full mb-1 z-50 cursor-pointer transition-all delay-100"
        [ngClass]="{'invisible': !displayButtonsParams, 'visible': displayButtonsParams}"
        [class.bottom-4]="!displayButtonsParams" [class.bottom-24]="displayButtonsParams"
        (click)="openModal('sar', 'fromEdit')">
        <mat-icon class="text-white" style="width: 30px; height: 30px; font-size: 30px;"
            [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>
    </div>

</div>
<div *ngIf="isLoggedIn" class="fixed bottom-4 right-4 z-50 cursor-pointer">
    <div class="flex flex-col bg-sky-500 p-4 rounded-full" (click)="displayButtons()">
        <mat-icon class="text-white" style="width: 30px; height: 30px; font-size: 30px;">
            warning
        </mat-icon>
    </div>
</div> -->